export const FLOATING_FULL_WIDTH = 'calc(100vw - 46px)';
